module.exports = __webpack_public_path__ + "static/media/TK_in_St._Remo_1998.6dfd4336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_aus_frueheren_jahren/TK_in_St._Remo_1998.jpg
// module id = 562
// module chunks = 0